module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.eot?8c65fd3e9b53a609735fd6335fd05841";